import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CurrentUserContext } from "../../App";
import temporaryAvatar from "../../assets/sampleAvatar.png";

export default function MobileTabBar({ unreadCount }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser } = useContext(CurrentUserContext);

  const activeColor = "#b997ff";

  function isActive(path) {
    return location.pathname.startsWith(path);
  }

  const avatarUrl =
    currentUser?.avatar && currentUser.avatar !== "sampleAvatar.png"
      ? currentUser.avatar
      : temporaryAvatar;

  const tabs = [
    {
      key: "memories",
      path: "/memories",
      label: "Memories",
      icon: (active) => (
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity={active ? "1" : "0.45"}>
            <path
              d="M0.668463 7.95046C-0.619985 4.36111 5.0862 2.61246 6.00646 6.01774L6.74282 7.4903L8.3074 3.90095C9.6327 1.98663 11.682 2.79654 12.541 3.44078C14.9707 2.77813 16.069 4.33044 16.3144 5.18943L17.787 5.6496C18.3023 3.80892 19.2595 2.78733 20.2719 2.88857C23.217 3.18308 23.6465 5.0974 23.4931 6.01774L18.2471 18.2583C16.7009 20.5408 15.0873 21.1727 14.4737 21.2034C13.6638 21.4979 11.8661 21.4489 11.0684 21.3875C9.50385 20.7126 6.24583 19.3075 5.73044 19.0866C5.21505 18.8658 4.77942 18.0129 4.62603 17.6141L0.668463 7.95046Z"
              stroke={active ? activeColor : "white"}
              strokeWidth="0.552207"
              strokeLinejoin="round"
            />
            <path
              d="M3.0614 6.47821C2.39876 6.6991 2.60123 7.36788 2.7853 7.67466C3.61362 9.88349 5.43593 14.7061 6.09858 16.3259C6.92689 18.3507 7.66317 17.5223 11.0684 19.0869C13.7927 20.3386 16.1917 17.8905 17.0507 16.51L18.2471 14.025L21.6524 5.55787C21.6217 5.3738 21.4315 4.95044 20.9161 4.72956C20.4007 4.50868 20.0878 4.94431 19.9958 5.18973C18.8607 7.82806 16.5537 13.2151 16.4064 13.6569C16.2224 14.2091 15.6702 14.3011 15.21 14.5772C14.7498 14.8534 12.8171 14.3932 12.7251 13.841C12.633 13.2888 11.6206 13.1047 11.0684 13.3808C10.5162 13.6569 9.13572 11.6321 9.41182 12.4605C9.6327 13.1231 9.19707 14.2705 8.95165 14.7613C8.36876 14.884 7.29503 15.019 7.66317 14.5772C8.12334 14.025 7.66317 13.3808 7.66317 12.7366C7.66317 12.2212 6.62011 11.6015 6.09858 11.356L4.16586 7.12245C4.07381 6.81567 3.72405 6.25733 3.0614 6.47821Z"
              fill={active ? activeColor : "white"}
              stroke={active ? activeColor : "white"}
              strokeWidth="0.552207"
              strokeLinejoin="round"
            />
            <line
              x1="10.5164"
              y1="5.56286"
              x2="8.77273"
              y2="10.0674"
              stroke={active ? activeColor : "white"}
              strokeWidth="1.28848"
              strokeLinecap="round"
            />
            <line
              x1="16.4066"
              y1="7.58727"
              x2="14.6629"
              y2="12.0918"
              stroke={active ? activeColor : "white"}
              strokeWidth="1.28848"
              strokeLinecap="round"
            />
            <path
              d="M13.8779 5.51367L11.6691 11.2198"
              stroke={active ? activeColor : "white"}
              strokeWidth="1.28848"
              strokeLinecap="round"
              fill={active ? activeColor : "white"}
            />
          </g>
        </svg>
      ),
    },
    {
      key: "search",
      path: "/search",
      label: "Search",
      icon: (active) => (
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="11"
            cy="11"
            r="7"
            stroke={active ? activeColor : "white"}
            strokeWidth="2"
            fill="none"
            opacity={active ? 1 : 0.45}
          />
          <line
            x1="16.5"
            y1="16.5"
            x2="21"
            y2="21"
            stroke={active ? activeColor : "white"}
            strokeWidth="2"
            strokeLinecap="round"
            opacity={active ? 1 : 0.45}
          />
        </svg>
      ),
    },
    {
      key: "connect",
      path: "/connect",
      label: "Connect",
      icon: (active) => (
        <svg
          width="22"
          height="22"
          viewBox="0 0 20 17"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 12.5592H12V12.0053C12 11.2667 11.6333 10.6709 10.9 10.2176C10.1667 9.76443 9.2 9.53783 8 9.53783C6.8 9.53783 5.83333 9.76443 5.1 10.2176C4.36667 10.6709 4 11.2667 4 12.0053V12.5592ZM8 8.53069C8.55 8.53069 9.02083 8.33346 9.4125 7.939C9.80417 7.54454 10 7.07035 10 6.51643C10 5.96251 9.80417 5.48831 9.4125 5.09385C9.02083 4.69939 8.55 4.50216 8 4.50216C7.45 4.50216 6.97917 4.69939 6.5875 5.09385C6.19583 5.48831 6 5.96251 6 6.51643C6 7.07035 6.19583 7.54454 6.5875 7.939C6.97917 8.33346 7.45 8.53069 8 8.53069ZM2 16.5878C1.45 16.5878 0.979167 16.3905 0.5875 15.9961C0.195833 15.6016 0 15.1274 0 14.5735V2.4879C0 1.93398 0.195833 1.45978 0.5875 1.06532C0.979167 0.670863 1.45 0.473633 2 0.473633H14C14.55 0.473633 15.0208 0.670863 15.4125 1.06532C15.8042 1.45978 16 1.93398 16 2.4879V7.02L20 2.99146V14.0699L16 10.0414V14.5735C16 15.1274 15.8042 15.6016 15.4125 15.9961C15.0208 16.3905 14.55 16.5878 14 16.5878H2ZM2 14.5735H14V2.4879H2V14.5735Z"
            fill={active ? activeColor : "white"}
            opacity={active ? 1 : 0.45}
          />
        </svg>
      ),
    },
    {
      key: "chat",
      path: "/chat",
      label: "Chat",
      icon: (active) => (
        <div style={{ position: "relative", display: "inline-flex" }}>
          <svg
            width="22"
            height="20"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 12.0944H11C11.2833 12.0944 11.5208 11.9979 11.7125 11.8048C11.9042 11.6118 12 11.3726 12 11.0872C12 10.8019 11.9042 10.5627 11.7125 10.3697C11.5208 10.1766 11.2833 10.0801 11 10.0801H5C4.71667 10.0801 4.47917 10.1766 4.2875 10.3697C4.09583 10.5627 4 10.8019 4 11.0872C4 11.3726 4.09583 11.6118 4.2875 11.8048C4.47917 11.9979 4.71667 12.0944 5 12.0944ZM5 9.07298H15C15.2833 9.07298 15.5208 8.97647 15.7125 8.78343C15.9042 8.5904 16 8.3512 16 8.06585C16 7.7805 15.9042 7.5413 15.7125 7.34827C15.5208 7.15523 15.2833 7.05872 15 7.05872H5C4.71667 7.05872 4.47917 7.15523 4.2875 7.34827C4.09583 7.5413 4 7.7805 4 8.06585C4 8.3512 4.09583 8.5904 4.2875 8.78343C4.47917 8.97647 4.71667 9.07298 5 9.07298ZM5 6.05159H15C15.2833 6.05159 15.5208 5.95507 15.7125 5.76203C15.9042 5.569 16 5.32981 16 5.04445C16 4.7591 15.9042 4.5199 15.7125 4.32687C15.5208 4.13384 15.2833 4.03732 15 4.03732H5C4.71667 4.03732 4.47917 4.13384 4.2875 4.32687C4.09583 4.5199 4 4.7591 4 5.04445C4 5.32981 4.09583 5.569 4.2875 5.76203C4.47917 5.95507 4.71667 6.05159 5 6.05159ZM4 16.1229L1.7 18.4393C1.38333 18.7582 1.02083 18.8296 0.6125 18.6533C0.204167 18.4771 0 18.1624 0 17.7091V2.02305C0 1.46913 0.195833 0.99494 0.5875 0.60048C0.979167 0.206019 1.45 0.00878906 2 0.00878906H18C18.55 0.00878906 19.0208 0.206019 19.4125 0.60048C19.8042 0.99494 20 1.46913 20 2.02305V14.1086C20 14.6626 19.8042 15.1368 19.4125 15.5312C19.0208 15.9257 18.55 16.1229 18 16.1229H4ZM3.15 14.1086H18V2.02305H2V15.2417L3.15 14.1086Z"
              fill={active ? activeColor : "white"}
              opacity={active ? 1 : 0.45}
            />
          </svg>
          {unreadCount > 0 && (
            <div
              style={{
                position: "absolute",
                top: -2,
                right: -4,
                width: 8,
                height: 8,
                backgroundColor: "#ff4444",
                borderRadius: "50%",
              }}
            />
          )}
        </div>
      ),
    },
    {
      key: "profile",
      path: "/profile",
      label: "Profile",
      icon: (active) => {
        return (
          <div
            style={{
              width: 26,
              height: 26,
              borderRadius: "50%",
              overflow: "hidden",
              border: active
                ? "2px solid #b997ff"
                : "2px solid transparent",
              flexShrink: 0,
            }}
          >
            <img
              src={avatarUrl}
              alt="Profile"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "50%",
                opacity: active ? 1 : 0.45,
              }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <nav
      className="mobile-tab-bar"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        height: "auto",
        paddingTop: "6px",
        paddingBottom: "calc(6px + env(safe-area-inset-bottom))",
        background: "rgba(16, 16, 16, 0.88)",
        backdropFilter: "blur(20px) saturate(180%)",
        WebkitBackdropFilter: "blur(20px) saturate(180%)",
        borderTop: "1px solid rgba(185, 151, 255, 0.08)",
        alignItems: "flex-start",
        justifyContent: "space-around",
        zIndex: 1000,
      }}
    >
      {tabs.map((tab) => {
        const active = isActive(tab.path);
        return (
          <div
            key={tab.key}
            onClick={() => navigate(tab.path)}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
              cursor: "pointer",
              gap: "2px",
              padding: "2px 0",
              transition: "transform 0.1s ease",
            }}
          >
            {tab.icon(active)}
            <span
              style={{
                fontSize: "9px",
                fontWeight: active ? 600 : 500,
                color: active ? activeColor : "rgba(255, 255, 255, 0.45)",
                letterSpacing: "0.02em",
                lineHeight: 1,
                marginTop: "1px",
              }}
            >
              {tab.label}
            </span>
          </div>
        );
      })}
    </nav>
  );
}
